import React, { useEffect, useState } from "react";
import { CustomGetAPI, CustomPostAPI } from "../Utils/APIConnector";
import { useParams } from "react-router-dom";
import { VenueDate, convertTo12HourFormat } from "../Utils/common";
import Loader from "../Utils/Loader";
import Swal from "sweetalert2";
import Popup from "../LiveScoreCardpopups/Popup";
import SlotSelector from "./SlotSelector";
import SameSurfaceBooking from "./SameSurfaceBooking";

export default function Bookingrequest() {
  const param = useParams();
  const isBulkRequest = new URLSearchParams(window.location.search).get(
    "isBulkRequest"
  );
  const [bookingData, setBookingData] = useState();
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedOtherSurface, setSelectedOtherSurface] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [step, setStep] = useState(1);
  useEffect(() => {
    CustomGetAPI(
      `/venue/Getofflinerequestdata/${param.bookingid}?isBulkRequest=${
        isBulkRequest ?? false
      }`
    ).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        setIsLoading(false);
        result = JSON.parse(result);
        if (result.status === "Success") {
          setBookingData(result?.venueDetails);
          if (result?.venueDetails?.otherAvailableCourts) {
            setSelectedOtherSurface(
              result?.venueDetails?.otherAvailableCourts[0]?.id
            );
          }
        } else if (result.status === "error") {
          Swal.fire({
            icon: "warning",
            title: "Link Expired!",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/home";
            }
          });
        }
      }
    });
  }, []);

  const handlerequest = (flag, selectedSlots = null, surfaceId = 0) => {
    setIsLoading(true);
    setShowPopup(false);
    CustomPostAPI(
      `/payment/BookingrequestAction/${flag}/${param.bookingid}?isBulkRequest=${
        isBulkRequest ?? false
      }`,
      JSON.stringify({
        selectedSlots: selectedSlots,
        selectedSurface: surfaceId,
      })
    ).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        result = JSON.parse(result);
        if (result.status === "success") {
          const message =
            flag === true
              ? "Thank you for accepting request, booking will be confirmed once payment is done!"
              : "Booking rejected";
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: message,
          }).then(() => {
            window.location.href = "/home";
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Link Expired!",
            showConfirmButton: true,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/home";
            }
          });
        }
      }
      setIsLoading(false);
    });
  };
  return (
    <React.Fragment>
      <>
        {isLoading ? (
          <Loader mt="20%" />
        ) : (
          <>
            {bookingData ? (
              <div className="row">
                <div className="col-12 bookingrequestdiv mt-3">
                  <h1 className="bookingrequestheading text-center m-0 py-2">
                    Booking Request
                  </h1>
                </div>
                <div className="col-12 bookingrequestdiv py-3 mt-3">
                  <div>
                    <img
                      src={bookingData?.venueImage}
                      alt=""
                      className="venuePhotos2 mb-3"
                    />
                  </div>
                  <div className="my-2">
                    <b>Venue :</b>
                    <span> {bookingData?.venueName}</span>
                  </div>
                  <div className="my-2">
                    <b>venue Address :</b>
                    <span> {bookingData?.venueAddress}</span>
                  </div>
                  <div className="my-2">
                    <b>Date of booking :</b>
                    <span> {VenueDate(bookingData?.date).formattedDate}</span>
                  </div>
                  <div className="my-2">
                    <b>Time: </b>
                    <span>{bookingData?.startTime}</span>
                  </div>
                  <div className="my-2">
                    <b>Duration: </b>
                    <span>
                      {bookingData?.slotDuration <= 1
                        ? `${bookingData?.slotDuration} hr`
                        : `${bookingData?.slotDuration} hrs`}
                    </span>
                  </div>

                  <div className="my-2">
                    <b>{bookingData?.categoryId == 1 ? "Sport" : "Events"} :</b>
                    <span> {bookingData?.sportName}</span>
                  </div>
                  <div className="my-2">
                    <b>{bookingData?.categoryId == 1 ? "Court" : "Space"} :</b>
                    <span> {bookingData?.surfaceName}</span>
                  </div>
                  {bookingData?.categoryId == 2 && (
                    <>
                      <div className="my-2">
                        <b>Purpose :</b>
                        <span> {bookingData?.purpose}</span>
                      </div>
                      <div className="my-2">
                        <b>No of People :</b>
                        <span> {bookingData?.peopleAttending}</span>
                      </div>
                    </>
                  )}
                  <div className="row mt-4 ">
                    <div className="col-6 text-end">
                      <button
                        className="venueListingTop booking  px-4 "
                        onClick={(e) => {
                          if (bookingData?.categoryId == 2 || isBulkRequest) {
                            handlerequest(false);
                          } else {
                            if (bookingData?.otherAvailableCourts?.length > 0) {
                              setStep(1);
                            } else {
                              setStep(2);
                            }
                            setShowPopup(true);
                          }
                        }}
                        // onClick={(e) => {
                        //   Swal.fire({
                        //     icon: "info",
                        //     title: "Review Booking update",
                        //     text: "Would you like to update the booking or reject it directly?",
                        //     confirmButtonText: "Update Availablity",
                        //     cancelButtonText: "Reject Booking",
                        //     showCancelButton: true,
                        //     allowOutsideClick: false,
                        //     allowEscapeKey: false,
                        //   }).then((result) => {
                        //     if (result.isConfirmed) {
                        //       setShowPopup(true);
                        //       return;
                        //     } else {
                        //       handlerequest(false);
                        //     }
                        //   });
                        // }}
                      >
                        Reject
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="venueListingTop booking  px-3 "
                        style={{ background: "rgb(76, 175, 80)" }}
                        onClick={(e) => handlerequest(true)}
                      >
                        Approve
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row"></div>
            )}
          </>
        )}
      </>
      <Popup
        show={showPopup}
        venueflag={1}
        onHide={() => {
          setShowPopup(false);
        }}
        title={
          step == 1 ? (
            <h5>
              Select an Available Turf for (
              {VenueDate(bookingData?.date).formattedDate} at{" "}
              {bookingData?.startTime} for {bookingData?.slotDuration}
              {bookingData?.slotDuration > 1 ? "hrs" : "hr"})
            </h5>
          ) : (
            <h5>
              Select Other Available Slots For ({bookingData?.surfaceName} on{" "}
              {VenueDate(bookingData?.date).formattedDate})
            </h5>
          )
        }
      >
        {step == 1 ? (
          <SameSurfaceBooking
            otherSurface={bookingData?.otherAvailableCourts}
            selectedOtherSurface={selectedOtherSurface}
            setSelectedOtherSurface={setSelectedOtherSurface}
          />
        ) : (
          <SlotSelector
            startDateTime={bookingData?.dateTime}
            availableSlots={bookingData?.availableSlots}
            duration={bookingData?.slotDuration * 60}
            handlerequest={handlerequest}
            selectedSlots={selectedSlots}
            setSelectedSlots={setSelectedSlots}
          />
        )}
        {step == 1 ? (
          <div className="row d-flex mt-3 justify-content-between align-items-center">
            <div className="col-12 col-md-4 text-center text-md-start">
              <ul
                className="text-decoration-underline mb-0 cursor-pointer"
                onClick={(e) => handlerequest(false)}
              >
                Skip & Reject
              </ul>
            </div>
            <div className="col-12 col-md-8 mt-3 mt-md-0 text-center text-md-end">
              <button
                className="staff-button-outline px-3 me-3"
                onClick={() => {
                  setStep(2);
                }}
              >
                Other Option
              </button>
              <button
                className="staff-button px-3"
                onClick={() => {
                  handlerequest(false, null, selectedOtherSurface);
                }}
              >
                Notify User
              </button>
            </div>
          </div>
        ) : (
          <div className="row d-flex mt-3 justify-content-between align-items-center">
            <div className="col-12 col-md-4 text-center text-md-start">
              <ul
                className="text-decoration-underline mb-0 cursor-pointer"
                onClick={(e) => handlerequest(false)}
              >
                Skip & Reject
              </ul>
            </div>
            <div className="col-12 col-md-8 mt-3 mt-md-0 text-center text-md-end">
              {bookingData?.otherAvailableCourts?.length > 0 && (
                <button
                  className="staff-button-outline px-3 me-3"
                  onClick={() => {
                    setStep(1);
                  }}
                >
                  Other Option
                </button>
              )}
              <button
                className="staff-button px-3"
                onClick={() => {
                  handlerequest(false, selectedSlots);
                }}
              >
                Notify User
              </button>
            </div>
          </div>
        )}
      </Popup>
    </React.Fragment>
  );
}
